import React from 'react';
import { PerformanceTier } from '~/types/performanceTier';

import IconType from '../IconType';
import SVGIcon from '../SVGIcon';

const CSS = require('./BadgeWithCrossIcon.module.scss');

type BadgeWithCrossIconProps = {
  variant?: 'default' | 'dialog' | 'white' | keyof typeof PerformanceTier;
} & IconType;

function BadgeWithCrossIcon({ variant, ...props }: BadgeWithCrossIconProps) {
  return (
    <SVGIcon {...props} size={props.size ?? 24} viewBox="0 0 24 24">
      <path
        d="M21.9999,11.9994946 C21.9999,17.5223126 17.5232234,21.9989892 12.0004054,21.9989892 C6.47758737,21.9989892 1.9999,17.5223126 1.9999,11.9994946 C1.9999,6.47667661 6.47758737,2 12.0004054,2 C17.5232234,2 21.9999,6.47667661 21.9999,11.9994946"
        data-variant={variant}
        className={CSS.Badge}
      />
      <path
        d="M9.28705,7.8725 L12.001,10.586 L14.71525,7.8725 C15.10525,7.4825 15.73825,7.4825 16.12925,7.8725 C16.51925,8.2635 16.51925,8.8965 16.12925,9.2865 L13.415,12 L16.12905,14.7145 C16.52005,15.1055 16.52005,15.7375 16.12905,16.1285 C15.93405,16.3235 15.67805,16.4215 15.42205,16.4215 C15.16605,16.4215 14.91005,16.3235 14.71505,16.1285 L12.001,13.414 L9.28725,16.1285 C9.09225,16.3235 8.83625,16.4215 8.58025,16.4215 C8.32425,16.4215 8.06825,16.3235 7.87325,16.1285 C7.48225,15.7375 7.48225,15.1055 7.87325,14.7145 L10.587,12 L7.87305,9.2865 C7.48305,8.8965 7.48305,8.2635 7.87305,7.8725 C8.26405,7.4825 8.89705,7.4825 9.28705,7.8725 Z"
        data-variant={variant}
        className={CSS.Cross}
      />
    </SVGIcon>
  );
}

export default BadgeWithCrossIcon;
